import React from "react";

import { Skeleton } from "../../../../../components/Skeleton";
import { SectionUnavailable } from "../../../components/SectionUnavailable";
import { RefreshFailedNotice } from "../../../components/RefreshFailedNotice";
import { SectionContentProps } from "./types";

export const SectionContent = <T,>({
  sectionName,
  section,
  onRetry,
  children,
}: SectionContentProps<T>) => (
  <>
    {section.state === "loading" && (
      <Skeleton variant="rectangular" height="6rem" />
    )}
    {section.state === "unavailable" && (
      <SectionUnavailable observedAt={section.observedAt} onRetry={onRetry} />
    )}
    {section.state === "available" && section.isRefreshFailed && (
      <RefreshFailedNotice sectionName={sectionName} onRetry={onRetry} />
    )}
    {section.state === "available" && children(section.data)}
  </>
);
